export default __webpack_public_path__ + "static/media/calendar.45681113.svg";